import React from 'react';

const ReposIpfsIpfsGui = () => (
  <div id='content' className='pt3 pr4 pl4 w-100'>
    <h1><span className='nav-category'>Repo:</span> ipfs/ipfs-gui</h1>

    <p>This repo contains issues, notes, and other process documents for the IPFS GUI working group. <a href="https://github.com/ipfs/ipfs-gui" target="_blank" rel="noopener noreferrer">View on GitHub</a></p>

    <h2>Nothing to see here!</h2>
    <p>This repo isn’t examined in detail because it’s primarily a “process” repo for discussions and overarching issues, rather than containing any user-facing code.</p>
  </div>
);

export default ReposIpfsIpfsGui;
